var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRisk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 38803"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 38802"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1077",
    d: "M9.21875 6.59168C9.21875 6.11584 9.56775 5.7301 9.99827 5.7301V5.7301C10.4288 5.7301 10.7778 6.11584 10.7778 6.59168V10.2808C10.7778 10.7566 10.4288 11.1423 9.99827 11.1423V11.1423C9.56775 11.1423 9.21875 10.7566 9.21875 10.2808V6.59168Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 117",
    d: "M10.7891 12.951C10.7891 13.4332 10.4353 13.8242 9.99902 13.8242C9.5627 13.8242 9.20898 13.4332 9.20898 12.951C9.20898 12.4687 9.5627 12.0778 9.99902 12.0778C10.4353 12.0778 10.7891 12.4687 10.7891 12.951Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 3 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6207 13.8383L11.1255 2.58828C10.6251 1.72161 9.3742 1.72162 8.87383 2.58828L2.37864 13.8383C1.87827 14.7049 2.50374 15.7883 3.50447 15.7883H16.4949C17.4956 15.7883 18.1211 14.7049 17.6207 13.8383ZM12.5977 1.73828C11.443 -0.261718 8.55629 -0.261719 7.40159 1.73828L0.9064 12.9883C-0.248301 14.9883 1.19507 17.4883 3.50447 17.4883H16.4949C18.8043 17.4883 20.2476 14.9883 19.0929 12.9883L12.5977 1.73828Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRisk);
export default __webpack_public_path__ + "static/media/risk.ca8551a06937cb56b25a399d36568f15.svg";
export { ForwardRef as ReactComponent };